import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { UserService } from '../../../services/UserService';
import { GetUserListPagingAndFilterRequest, initialGetUserListPagingAndFilterRequest } from '../../../models/request/user/GetUserListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetUserListPagingAndFilterResponse, GetUserListPagingAndFilterResponseData, GetUserListPagingAndFilterResponseItem, initialGetUserListPagingAndFilterResponseData } from '../../../models/response/user/GetUserListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { DeleteUserResponse } from '../../../models/response/user/DeleteUserResponse';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import UserListFilters from './Components/UserListFilters';
import { ExportUserListResponse } from '../../../models/response/user/ExportUserListResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadList } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { CompanyService } from '../../../services/CompanyService';
import { RoleService } from '../../../services/RoleService';

const UserList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ayarlar > Kullanıcı Tanımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetUserListPagingAndFilterResponseData>(initialGetUserListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetUserListPagingAndFilterRequest>(initialGetUserListPagingAndFilterRequest);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ad Soyad', name: 'userNameSurname', order: 0, isVisible: true },
            { title: 'Kullanıcı Adı', name: 'userUsername', order: 0, isVisible: true },
            { title: 'E-Posta', name: 'userEmail', order: 0, isVisible: true },
            { title: 'Telefon', name: 'userPhone', order: 0, isVisible: true },
            { title: 'Şirket', name: 'userCompanyName', order: 0, isVisible: true },
            { title: 'Roller', name: 'userRolesStr', order: 0, isVisible: true },
            { title: 'Sürücü', name: 'driverName', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteUser = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.userId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteUserResponse = await UserService.deleteUser(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateUser = async (_id: string | undefined = undefined) => {
        navigate('/user/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].userId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetUserListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            dispatch(storeActivityIndicator(true));

            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            var response: GetUserListPagingAndFilterResponse = await UserService.getUserListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.userId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportUserListResponse = await UserService.exportUserList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.userId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Roller (bellekte birleştirilen metin)
    // ve oluşturan/güncelleyen bilgisi listede yok.
    const sortableColumns = [
        'userNameSurname', 'userUsername', 'userEmail', 'userPhone',
        'userCompanyName', 'driverName'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (UserManager.ApplyColumnFilters) aynı. Şirket ve rollerde seçilenlerden birine
    // bağlı kullanıcılar gelir; seçenekler kullanıcı ekleme ekranındaki listeler.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        userNameSurname: { type: 'text' },
        userUsername: { type: 'text' },
        userEmail: { type: 'text' },
        userPhone: { type: 'text' },
        userCompanyName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCompany: true }), 'companyId', x => x.name) },
        userRolesStr: { type: 'select', loadOptions: () => loadList(RoleService.getRoleList(), 'roleId', x => x.name) },
        driverName: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetUserListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "createdUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.userId)} onDoubleClick={() => updateUser(item.userId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.userId)} onDoubleClick={() => updateUser(item.userId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.userId)} onDoubleClick={() => updateUser(item.userId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <UserListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteUser}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateUser}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.userId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default UserList;